export default {
  /**
   * 极验证的展现形式,可选值: float、popup、custom、bind, 参数同极验证的product参数
   */
  product: {
    type: String,
    default: 'popup'
  },
  /**
   * 按钮的长度,带单位的数值字符串,单位可以是px、em、%、rem、pt, 参数同极验证的width参数
   */
  width: {
    type: String,
    default: '300px'
  },
  /**
   * 前端国际化语言标记值
   */
  lang: {
    type: String,
    default: 'zh-CN'
  },
  /**
   * 是否使用https请求, 参数同极验证的https参数
   */
  https: {
    type: Boolean,
    default: false
  },
  /**
   * 极验证中单个请求的响应超时时间,默认为30000ms,参数同极验证的timeout参数
   */
  timeout: {
    type: Number,
    default: 30000
  },
  /**
   * 后续弹出的验证的区域————相关dom区域的的节点id,当product值为custom时,该参数必填,同极验证的area参数
   */
  area: {
    type: String,
    default: ''
  },
  /**
   * 自定义弹出验证时弹出验证层的宽度,当product值为custom时,该参数有效,默认为area区域的90%, 同极验证的next_width参数
   */
  next_width: {
    type: String,
    default: '90%'
  },
  /**
   * 自定义弹出验证时弹出层的透明蒙版背景色值, 默认为黑色, 透明度60%, 当product值为custom时,该参数有效, 同极验证的bg_color参数
   */
  bg_color: {
    type: String,
    default: '#000'
  },
  /**
   * 极验证初始化的参数获取接口
   */
  action: {
    type: String,
    default: 'sso/deed_captcha'
  },
  /**
   * 需要极验证的提交表单的数据对象,这里传进来的作用是————校验过极验证之后未提交表单又修改了其他字段的值时可以监听数据变化重置极验证
   */
  formData: {
    type: Object,
    default: function() {
      return {}
    }
  }
};
